import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class MessagesControlService {
    constructor() { }

    private _toBeMessagedRows = new BehaviorSubject<any>(null);
    toBeMessagedRows = this._toBeMessagedRows.asObservable();

    setMessagedRows(rows) {
        this._toBeMessagedRows.next(rows);
    }

    getMessagedRows() {
        return this._toBeMessagedRows;
    }

    private _messageBtnCondition = new BehaviorSubject<boolean>(false);
    messageBtnCondition = this._messageBtnCondition.asObservable();

    toggleMessageBtn(toggleBtn: boolean) {
        this._messageBtnCondition.next(toggleBtn);
    }

    getMessageBtnCondition() {
        return this._messageBtnCondition;
    }

}